import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { EmailCustomization, EmailScenario } from 'src/app/shared/models/emailCustomization';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';

@Injectable()
export class EmailCustomizationService extends BaseService {
  private basePath = 'emailmetadata';
  private teamInvitationBasePath = `${this.basePath}/team`;

  public applicationConfirmationEmail = new Subject<EmailCustomization>();
  public applicationInvitationEmail = new Subject<EmailCustomization>();
  public evaluationTemplateConfirmationEmailCustomization = new Subject<EmailCustomization>();
  public evaluationTemplateInvitationEmailCustomization = new Subject<EmailCustomization>();
  public surveyTemplateConfirmationEmailCustomization = new Subject<EmailCustomization>();
  public surveyTemplateInvitationEmailCustomization = new Subject<EmailCustomization>();

  constructor() {
    super();
  }

  getTeamEmailCustomization(
    teamId: string,
    scenario: EmailScenario
  ): Observable<EmailCustomization> {
    return this.get(this.getTeamInvitationPath(teamId, scenario)).pipe(
      map(this.convertEmailCustomization)
    );
  }

  updateTeamEmailCustomization(
    teamId: string,
    emailCustomization: EmailCustomization
  ): Observable<any> {
    var body = JSON.stringify(emailCustomization);
    return this.post(this.getTeamInvitationPath(teamId, emailCustomization.scenario), body);
  }

  resetTeamEmailCustomization(
    teamId: string,
    scenario: EmailScenario
  ): Observable<EmailCustomization> {
    return this.delete(this.getTeamInvitationPath(teamId, scenario)).pipe(
      map(this.convertEmailCustomization)
    );
  }

  private getTeamInvitationPath(teamId: string, scenario: EmailScenario) {
    return `${this.teamInvitationBasePath}/${teamId}/${scenario}`;
  }

  private convertEmailCustomization(emailCustomization: EmailCustomization): EmailCustomization {
    return EmailCustomization.parse(emailCustomization);
  }

  getAllApplicationEmailCustomization(id: string) {
    this.get<EmailCustomization[]>(`${this.basePath}/application/${id}`, true)
      .pipe(
        map((data) => {
          if (data) {
            return data.map(this.convertEmailCustomization);
          }
        })
      )
      .subscribe((result) => {
        if (result) {
          const confirm = result.find((x) => x.isConfirmationScenario());
          const invent = result.find((x) => x.isDefaultScenario());

          this.applicationConfirmationEmail.next(confirm);
          this.applicationInvitationEmail.next(invent);
        }
      });
  }

  updateApplicationEmail(appId: string, emailCustomization: EmailCustomization) {
    var body = JSON.stringify(emailCustomization);
    this.post(`${this.basePath}/application/${appId}/${emailCustomization.scenario}`, body)
      .pipe(
        map((data) => {
          return this.convertEmailCustomization(data);
        })
      )
      .subscribe((result) => {
        if (result.scenario == EmailScenario.Default) {
          this.applicationInvitationEmail.next(result);
        } else if (result.scenario == EmailScenario.Confirmation) {
          this.applicationConfirmationEmail.next(result);
        }
      });
  }

  getAllEvaluationTemplateEmailCustomization(id: string) {
    this.get<EmailCustomization[]>(`${this.basePath}/evaluation/${id}`, true)
      .pipe(
        map((data) => {
          if (data) {
            return data.map(this.convertEmailCustomization);
          }
        })
      )
      .subscribe((result) => {
        if (result) {
          const confirmation = result.find((x) => x.isConfirmationScenario());
          const invitation = result.find((x) => x.isDefaultScenario());

          this.evaluationTemplateConfirmationEmailCustomization.next(confirmation);
          this.evaluationTemplateInvitationEmailCustomization.next(invitation);
        }
      });
  }

  updateEvaluationTemplateEmailCustomization(id: string, emailCustomization: EmailCustomization) {
    var body = JSON.stringify(emailCustomization);
    this.post(`${this.basePath}/evaluation/${id}/${emailCustomization.scenario}`, body)
      .pipe(
        map((data) => {
          return this.convertEmailCustomization(data);
        })
      )
      .subscribe((result) => {
        if (result.scenario == EmailScenario.Default) {
          this.evaluationTemplateInvitationEmailCustomization.next(result);
        } else if (result.scenario == EmailScenario.Confirmation) {
          this.evaluationTemplateConfirmationEmailCustomization.next(result);
        }
      });
  }

  getAllSurveyTemplateEmailCustomization(id: string) {
    this.get<EmailCustomization[]>(`${this.basePath}/survey/${id}`, true)
      .pipe(
        map((data) => {
          if (data) {
            return data.map(this.convertEmailCustomization);
          }
        })
      )
      .subscribe((result) => {
        if (result) {
          const confirmation = result.find((x) => x.isConfirmationScenario());
          const invitation = result.find((x) => x.isDefaultScenario());

          this.surveyTemplateConfirmationEmailCustomization.next(confirmation);
          this.surveyTemplateInvitationEmailCustomization.next(invitation);
        }
      });
  }

  updateSurveyTemplateEmailCustomization(id: string, emailCustomization: EmailCustomization) {
    var body = JSON.stringify(emailCustomization);
    this.post(`${this.basePath}/survey/${id}/${emailCustomization.scenario}`, body)
      .pipe(
        map((data) => {
          return this.convertEmailCustomization(data);
        })
      )
      .subscribe((result) => {
        if (result.scenario == EmailScenario.Default) {
          this.surveyTemplateInvitationEmailCustomization.next(result);
        } else if (result.scenario == EmailScenario.Confirmation) {
          this.surveyTemplateConfirmationEmailCustomization.next(result);
        }
      });
  }
}
